// eslint-disable-next-line
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import '../css/history.css';

import { AppContext } from '../AppContext';
import Container from '../basicComponents/Container';
import Text from '../basicComponents/Text';
import { LogHistory, LogHistoryResponse } from '../data/LogHistory';
import SessionHeader from '../appComponents/SessionHeader';
import TextClick from '../basicComponents/TextClick';
import LogRecord from '../data/LogRecord';
import { RecordNavigation } from '../App';

export interface HistoryPageProps extends RouteComponentProps { 
    curRecord: LogRecord | undefined;
    recordNavigation: RecordNavigation;
    setCurRecord: (record: LogRecord) => void;
}

export interface HistoryPageState { 
    entries: LogHistory[] | undefined;
}

class HistoryPageComponent extends React.Component<HistoryPageProps, HistoryPageState> {

    // app context
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>;

    private sessionId: string;

    private recordNavigation: RecordNavigation;

    constructor(props: HistoryPageProps) {

        super(props);

        const path = this.props.history.location.pathname.split("/");
        this.sessionId = path[path.length - 1];

        this.recordNavigation = { 
            ...this.props.recordNavigation,
            moveToRecord: this.moveToRecord,
        };

        this.state = {
            entries: undefined,
        };

    }

    public shouldComponentUpdate(): boolean {
        console.log("shouldComponentUpdate called");
        const path = this.props.history.location.pathname.split("/");
        const curSessionId = path[path.length - 1];
        if (this.sessionId !== curSessionId) {

            this.sessionId = curSessionId;
            this.setState({ entries: undefined });

            // get logHistory
            this.context.restAppService.request_get('logHistory/record/' + this.sessionId, this.context.user.getToken(),
                (data): void => {
                    const response = JSON.parse(data) as LogHistoryResponse;
                    this.setState({ entries: response.entries });
                },
                (status, text): void => {
                    console.log(`request failure ${status} ${text}`)
                }
            );

        }
        return true;
    }

    public render(): JSX.Element {

        if (this.state.entries === undefined) {
            return <div />
        }

		if (this.props.curRecord === undefined) {
			return <div />
		}
        
        return (
            <Container className='history-page'>
                <Container className='session-line'>
                    <SessionHeader curRecord={this.props.curRecord} recordNavigation={this.recordNavigation} />
                    <div className='session-space' />
                    <TextClick className='session-button' name='dialog' onClick={this.handleButtonClick}>Dialog</TextClick>
                    <TextClick className='session-button' name='logging' onClick={this.handleButtonClick}>Logging</TextClick>
                </Container>
                <Container className='history-list'>
                    {this.state.entries.map( (entry, idx) => {

                        entry.logDate = entry.logDate.replace('T', ' ');

                        return (
                            <React.Fragment key={idx}>
                                <Text className={idx % 2 === 0 ? 'history-value-even' : 'history-value-odd'}>{entry.logDate}</Text>
                                <Text className={idx % 2 === 0 ? 'history-value-even' : 'history-value-odd'}>{entry.step}</Text>
                                <Text className={idx % 2 === 0 ? 'history-value-even' : 'history-value-odd'}>{JSON.stringify(entry.dcs)}</Text>
                                <Text className={idx % 2 === 0 ? 'history-value-even' : 'history-value-odd'}>{JSON.stringify(entry.dcr)}</Text>
                            </React.Fragment>
                        );
                    })}
                </Container>
            </Container>
            
        );

    }

    public componentDidMount(): void {

        // get log record if necessary
        if (this.props.curRecord === undefined) {

            this.context.restAppService.request_get('logRecord/request/' + this.sessionId, this.context.user.getToken(),
                (data): void => {

                    // get response
                    const response = JSON.parse(data) as LogRecord;

                    // set curRecord
                    this.props.setCurRecord(response);

                    // set sidebar
                    this.context.app.addSidebar({ name: 'HTY ' + this.sessionId, link: '/logHistory/' + this.sessionId });      

                },
                (status, text) => {
                    console.log(`request failure ${status} ${text}`)
                }
            );
        }

        // get logHistory
        this.context.restAppService.request_get('logHistory/record/' + this.sessionId, this.context.user.getToken(),
            (data): void => {
                const response = JSON.parse(data) as LogHistoryResponse;
                this.setState({ entries: response.entries });
            },
            (status, text): void => {
                console.log(`request failure ${status} ${text}`)
            }
        );

    }

    public moveToRecord = (nextRecord: LogRecord): void => {

        if (this.props.curRecord) {

            // replace entry in sidebar
            this.context.app.replaceSidebar(
                { name: 'HTY ' + this.props.curRecord.sessionId, link: '/logHistory/' + this.props.curRecord.sessionId }, 
                { name: 'HTY ' + nextRecord.sessionId, link: '/logHistory/' + nextRecord.sessionId }
                );

            // navigate to new index
            this.props.setCurRecord(nextRecord);
            this.props.history.push('/logHistory/' + nextRecord.sessionId);

        }

    }

    private handleButtonClick = (event: React.MouseEvent<HTMLSpanElement>): void => {

        const target = event.currentTarget;
        const name = target.dataset.name;

        switch (name) {
            case 'dialog':
                this.context.app.addSidebar({ name: 'DLG ' + this.sessionId, link: '/dialog/' + this.sessionId });
                this.props.history.push('/dialog/' + this.sessionId);
                break;
            case 'logging': 
                this.context.app.addSidebar({ name: 'LOG ' + this.sessionId, link: '/logging/' + this.sessionId });
                this.props.history.push('/logging/' + this.sessionId);
                break;
        }

    }

}

const HistoryPage = withRouter(HistoryPageComponent);
export default HistoryPage;
